// ui.module.ts
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { IconComponent } from './icon/icon.component';
import { ButtonComponent } from './buttons/button/button.component';
import { NavButtonComponent } from './buttons/nav-button/nav-button.component';
import { SectionLabelComponent } from './section-label/section-label.component';
import { CurrencyButtonComponent } from './buttons/currency-button/currency-button.component';
import { CurrencyIconComponent } from './currency-icon/currency-icon.component';
import { GameIconComponent } from './game-icon/game-icon.component';
import { GameTitleComponent } from './game-title/game-title.component';
import { TabBarComponent } from './tabs/tab-bar/tab-bar.component';
import { TabButtonComponent } from './tabs/tab-button/tab-button.component';
import { DropDownButtonComponent } from './buttons/drop-down-button/drop-down-button.component';
import { TranslocoModule } from '@jsverse/transloco';
import { WagerCardComponent } from './drawers/wager-drawer/wager-card/wager-card.component';
import { LeaderboardListCellComponent } from './leaderboard-list-cell/leaderboard-list-cell.component';
import { WagerDrawerComponent } from './drawers/wager-drawer/wager-drawer.component';
import { WaitingForPaymentDrawerComponent } from './drawers/waiting-for-payment-drawer/waiting-for-payment-drawer.component';
import { PaymentDrawerComponent } from './drawers/payment-drawer/payment-drawer.component';
import { OperatorPayTemplateComponent } from './drawers/payment-drawer/operator-pay-template/operator-pay-template.component';
import { PipeModule } from '../core/pipes/pipes.module';
import { TournamentRulesComponent } from './tournament-rules/tournament-rules.component';
import { QRCodeModule } from 'angularx-qrcode';
import { GameButtonComponent } from './buttons/game-button/game-button.component';
import { IconButtonComponent } from './buttons/icon-button/icon-button.component';
import { PillTabButtonComponent } from './tabs/pill-tab-button/pill-tab-button.component';
import { BountyPillComponent } from './bounty-pill/bounty-pill.component';
import { LightningWebPayTemplateComponent } from './drawers/payment-drawer/lightning-web-pay-template/lightning-web-pay-template.component';
import { LightningNativePayTemplateComponent } from './drawers/payment-drawer/lightning-native-pay-template/lightning-native-pay-template.component';
import { LightningOperatorPayTemplateComponent } from './drawers/payment-drawer/lightning-operator-pay-template/lightning-operator-pay-template.component';
import { ProfileButtonComponent } from './buttons/profile/profile-button.component';

@NgModule({
  imports: [IonicModule, CommonModule, PipeModule, TranslocoModule, QRCodeModule],
  declarations: [
    LoadingSpinnerComponent,
    IconComponent,
    ButtonComponent,
    GameButtonComponent,
    IconButtonComponent,
    NavButtonComponent,
    SectionLabelComponent,
    CurrencyButtonComponent,
    CurrencyIconComponent,
    GameIconComponent,
    GameTitleComponent,
    PillTabButtonComponent,
    TabBarComponent,
    TabButtonComponent,
    DropDownButtonComponent,
    WagerCardComponent,
    LeaderboardListCellComponent,
    WagerDrawerComponent,
    WaitingForPaymentDrawerComponent,
    PaymentDrawerComponent,
    LightningWebPayTemplateComponent,
    LightningNativePayTemplateComponent,
    LightningOperatorPayTemplateComponent,
    OperatorPayTemplateComponent,
    BountyPillComponent,
    TournamentRulesComponent,
    ProfileButtonComponent,
  ],
  exports: [
    LoadingSpinnerComponent,
    IconComponent,
    ButtonComponent,
    GameButtonComponent,
    IconButtonComponent,
    NavButtonComponent,
    SectionLabelComponent,
    CurrencyButtonComponent,
    CurrencyIconComponent,
    GameIconComponent,
    GameTitleComponent,
    PillTabButtonComponent,
    TabBarComponent,
    DropDownButtonComponent,
    WagerCardComponent,
    LeaderboardListCellComponent,
    WagerDrawerComponent,
    WaitingForPaymentDrawerComponent,
    PaymentDrawerComponent,
    LightningWebPayTemplateComponent,
    LightningNativePayTemplateComponent,
    LightningOperatorPayTemplateComponent,
    OperatorPayTemplateComponent,
    BountyPillComponent,
    TournamentRulesComponent,
    ProfileButtonComponent,
  ],
})
export class UIModule {}
